module.exports = __webpack_public_path__ + "img/makkis.4dc0c879.svg";